import { Loader, Table, TableColumn } from '@wix/design-system';
import React from 'react';

import { biHelpCenter } from '../../../util/bi';
import { CategoryItemType } from '../../api/getCategories';
import { usePageEngagement } from '../../hooks/usePageEngagement';
import s from './CategoriesList.scss';
import { CategoryItem } from './CategoryItem';

type CategoriesListProps = {
  categories: CategoryItemType[];
};

export const dataHook = 'help-center-categories-list';

const categoriesTableColumns: TableColumn<CategoryItemType>[] = [
  {
    title: 'title',
    render: (item, i) => <CategoryItem category={item} index={i} />,
    style: { boxShadow: 'unset', padding: 'unset' },
  },
];

export const CategoriesList: React.FC<CategoriesListProps> = ({
  categories,
}) => {
  const { onScroll } = usePageEngagement();

  React.useEffect(() => {
    if (categories.length) {
      // Fix race condition with state monitor
      setTimeout(() => {
        biHelpCenter.categoriesList = categories;
        biHelpCenter.logCategoriesPresented(categories);
      }, 0);
    }
  }, [categories]);

  return (
    <div
      data-hook={dataHook}
      className={s.categoriesListContainer}
      onScroll={onScroll}
    >
      <Table
        data={categories}
        columns={categoriesTableColumns}
        loader={<Loader />}
      >
        <Table.Content titleBarVisible={false} />
      </Table>
    </div>
  );
};
